module.exports = __webpack_public_path__ + "assets/202509252035/img/timeline2.d13526c7.png";